import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import Suggestion from "@tiptap/suggestion";
import EntityLinkComponent from "./EntityLinkComponent";

const EntityLink = Node.create({
  name: "entityLink",
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addOptions() {
    return {
      suggestion: {},
    };
  },

  addAttributes() {
    return {
      entityType: { default: null },
      entityId: { default: null },
      label: { default: null },
      prefix: { default: null },
      route: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-entity-link]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { "data-entity-link": "" }),
      HTMLAttributes.label,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(EntityLinkComponent);
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export default EntityLink;
